import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { ReadTimeQuery } from './ReadTimeQuery.graphql.ts';
import type {
	ReadTimeQuery as ReadTimeQueryType,
	ReadTimeQueryVariables,
} from './__types__/ReadTimeQuery.ts';

type PreloadReadTimeParams = Pick<ReadTimeQueryVariables, 'includeContentBody' | 'status'> & {
	contentId: ReadTimeQueryVariables['contentId'];
	useCache: boolean;
};

export function preloadReadTime({
	contentId,
	includeContentBody = true,
	status,
	useCache,
}: PreloadReadTimeParams) {
	return query<ReadTimeQueryType, ReadTimeQueryVariables>({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: ReadTimeQuery,
		variables: {
			contentId,
			includeContentBody,
			status,
		},
		fetchPolicy: useCache ? 'cache-first' : 'network-only',
	});
}
